import { render, staticRenderFns } from "./LocationSummaryLegend.vue?vue&type=template&id=0c22a700&"
import script from "./LocationSummaryLegend.vue?vue&type=script&lang=js&"
export * from "./LocationSummaryLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c22a700')) {
      api.createRecord('0c22a700', component.options)
    } else {
      api.reload('0c22a700', component.options)
    }
    module.hot.accept("./LocationSummaryLegend.vue?vue&type=template&id=0c22a700&", function () {
      api.rerender('0c22a700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/location-summary/LocationSummaryLegend.vue"
export default component.exports